export default __webpack_public_path__ + "static/media/placeholder_business05-jp-web.e2c62d69.png";